import React, { memo } from 'react';
import { ListTypeTokens, } from '@voltmoney/schema';
import ListBase from './List.base';
import ThemeProvider from '@voltmoney/theme';
const List = ({ type = ListTypeTokens.CHECKLIST, ...props }) => {
    const theme = ThemeProvider.getTheme();
    const listThemeProps = theme.list[type];
    switch (type) {
        case ListTypeTokens.CHECKLIST:
            return (React.createElement(ListBase, { ...listThemeProps, ...props }));
        case ListTypeTokens.DEFUALTLIST:
            return React.createElement(React.Fragment, null);
        default:
            return React.createElement(React.Fragment, null);
    }
};
export default memo(List);
export { List };
